import { Box, Text } from '@vouched.id/vault';
import React from 'react';
import { Dropdown } from '../Dropdown';
import { DLVCaption } from './DLVCaption';
import { DLVSuccessfulResult } from './DLVSuccessfulResult';
import { getVisualDlvStatus } from './DLVUtils';
export const DLVDropdown = ({ dlvJobResult, jobStatus, dlvSubmittedData }) => {
    if (dlvJobResult.result?.wasCheckPerformed) {
        return (React.createElement(DLVSuccessfulResult, { dlvResult: dlvJobResult.result, dlvSubmittedData: dlvSubmittedData, jobStatus: jobStatus }));
    }
    return (React.createElement(Dropdown, { title: "DLV" },
        React.createElement(Box, null,
            React.createElement(DLVCaption, null),
            React.createElement(Box, { display: "flex", style: { gap: '20px' } },
                React.createElement(Text, null, "Status:"),
                React.createElement(Text, { style: { fontWeight: '600' } }, getVisualDlvStatus(dlvJobResult.dlvStatusMessage, dlvJobResult.error, dlvJobResult.result?.stateSupported))))));
};
